import { useContext } from 'react';

import CubohActionBarContext from 'context/CubohActionBarContext';

export const useCubohActionBar = () => useContext(CubohActionBarContext);
